import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { KeyEventUtil } from 'utils'

const FechaHastaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('select2-reporteCompras-proveedor', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='FEC. HASTA' htmlFor='date-reporteCompras-hasta' md={6} alignRightAt='md' />
      <Col md={6}>
        <Field name='fechaHasta'>
          {({ field }) => (
            <Form.InputDate
              {...field}
              id='date-reporteCompras-hasta'
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaHastaFormGroup)
